import { buildApiParamsPagination } from '@sonifi/wb-widget/store/tableConfig/tableConfigInitialState';
import { store } from '@sonifi/wb-core/store/store';
import {
  getIrdOrderById,
  getIrdOrders,
  initRowExpanded,
} from '../Orders/services/irdOrders.service';
import { checkRevenueCenter } from '../Settings/services/irdSettings.service';
import { TABLE_KEYS } from '@sonifi/wb-widget/store/tableConfig/tableConfigConstants';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';

function checkIfIrdOrdersAreLoaded(apiParams) {
  const state = store.getState();
  const {
    irdOrders: { loadingIrdOrders, orders },
  } = state;
  const currentPagination = state.tableConfig.pagination[TABLE_KEYS.irdOrders];

  // If orders are loaded and params match, just update expanded state without refetching
  if (
    loadingIrdOrders === LOADING_STATUS.success &&
    orders.length > 0 &&
    currentPagination &&
    currentPagination.page === apiParams.page &&
    currentPagination.pageSize === apiParams.pageSize &&
    currentPagination.query === apiParams.query &&
    currentPagination.sortBy === apiParams.sortBy &&
    currentPagination.sortDir === apiParams.sortDir
  ) {
    return true;
  }
  return false;
}

export async function loaderIrdOrders({ params, request }) {
  const apiParams = buildApiParamsPagination(request);
  const { groupId } = params;
  store.dispatch(initRowExpanded(null));

  const {
    irdSettings: { revenueCenterSelected },
  } = store.getState();

  const revenueCenter = await store.dispatch(
    checkRevenueCenter({ groupId: parseInt(groupId), revenueCenterSelected }),
  );

  if (checkIfIrdOrdersAreLoaded(apiParams)) {
    return {};
  }

  await store.dispatch(
    getIrdOrders({
      ...apiParams,
      revenueCenterId: revenueCenter?.id,
    }),
  );
  return {};
}

export async function loaderIrdOrderById({ params, request }) {
  const { id } = params;
  const expandedRowId = parseInt(id);

  const apiParams = buildApiParamsPagination(request);
  if (!checkIfIrdOrdersAreLoaded(apiParams)) {
    await loaderIrdOrders({ request });
  }

  store.dispatch(initRowExpanded(expandedRowId));
  if (expandedRowId) {
    const {
      irdSettings: { revenueCenterSelected },
    } = store.getState();
    // Don't wait here because uses the internal loading in the WbTable
    store.dispatch(
      getIrdOrderById({
        id: expandedRowId,
        revenueCenterId: revenueCenterSelected?.id,
      }),
    );
  }
  return {};
}
